import * as yup from 'yup';

// import { scopeTypes } from '../../hooks/api/useGroups'

export const validationSchema = yup.object({
    // name: yup
    //     .string()
    //     .required("Required"),
    // // description: yup
    // //     .string()
    // //     .required("Required"),
    // status: yup
    //     .bool()
    //     .required("Required"),
    // actionType: yup
    //     .string()
    //     .oneOf(scopeTypes.supplier.map(i => i.id))
    //     .required("Required"),
    // userId: yup
    //     .array()
    //     .of(yup.string())
    //     .min(1, `At least 1 selection`)
    //     .required("Required"),
})

export const initialValues = {
    module: "", /* required */
    file_ref: "", /* required */
    type: "", /* required */
    tag: "",
    name: "", /* required */
    description: "",
    refer_id: "", /* required */
    base64_code: ""
}